import styled from "styled-components";

export const Container = styled.main`
  max-width: 1368px;
  margin: 0 auto;
`;
